import React from 'react';

import cn from 'clsx';

import styles from './event-property.module.scss';

interface IEventPropertyProps {
  className?: string;
  dataTestId?: string;
}

export const EventProperty: React.FC<
  React.PropsWithChildren<IEventPropertyProps>
> = ({ children, className, dataTestId }) => {
  return (
    <div
      data-testid={dataTestId}
      className={cn(styles.eventProperty, className)}
    >
      {children}
    </div>
  );
};
